import { useLocation } from "react-router-dom";
import { Card, Descriptions, Button, Space } from "antd";
import { customBaseUrl, httpDelete } from "../../store/http";
import Layout from "../../components/Layout";
import Swal from "sweetalert2";

export const AdminDetailsScreen = () => {
  // sekx-note: There would never be a reason to access this page outside the admin table. So we can safely assume that the user details are always passed in the location state.
  const location = useLocation();
  const userDetails = location.state;

  const handleDeleteAdmin = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          return handleDelete();
        }
        return Promise.reject("cancelled");
      })
      .then(() => {
        return Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
        });
      })
      .catch((error) => {
        console.log({ error });
        if (error === "cancelled") return;

        Swal.fire({
          title: "Error!",
          text: "An error occurred while deleting the admin.",
          icon: "error",
        });
      });
  };

  const handleDelete = async () => {
    const api = `${customBaseUrl.authUrl}/api/v1/admin/users/${userDetails.id}`;
    const response = await httpDelete(api);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  };
  return (
    <Layout>
      <Card
        title={`User Details: ${userDetails.fullName || userDetails.email}`}
        extra={
          <Space>
            {userDetails.isActive ? (
              <Button type="primary" danger onClick={handleDeleteAdmin}>
                Delete
              </Button>
            ) : null}
          </Space>
        }
      >
        <Descriptions bordered column={{ xs: 1, sm: 2, md: 3 }}>
          <Descriptions.Item label="Full Name">
            {userDetails.fullName}
          </Descriptions.Item>
          <Descriptions.Item label="Primary Account Number">
            {userDetails.primaryAccountNumber}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {userDetails.email}
          </Descriptions.Item>
          <Descriptions.Item label="Phone Number">
            {userDetails.phoneNumber}
          </Descriptions.Item>
          <Descriptions.Item label="Referral Code">
            {userDetails.referralCode}
          </Descriptions.Item>
          <Descriptions.Item label="User Type">
            {userDetails.userType}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            {userDetails.status}
          </Descriptions.Item>
          <Descriptions.Item label="KYC Status">
            {userDetails.tierName}
          </Descriptions.Item>
          <Descriptions.Item label="Date of Birth">
            {userDetails.dateOfBirth}
          </Descriptions.Item>
          <Descriptions.Item label="Gender">
            {userDetails.gender}
          </Descriptions.Item>
          <Descriptions.Item label="BVN">{userDetails.bvn}</Descriptions.Item>
          <Descriptions.Item label="Street Address">
            {userDetails.streetAddress}
          </Descriptions.Item>
          <Descriptions.Item label="City">{userDetails.city}</Descriptions.Item>
          <Descriptions.Item label="State">
            {userDetails.state}
          </Descriptions.Item>
          <Descriptions.Item label="Country">
            {userDetails.country}
          </Descriptions.Item>
          <Descriptions.Item label="Last Login At">
            {userDetails.lastLoginAt
              ? new Date(userDetails.lastLoginAt).toLocaleString()
              : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {userDetails.createdAt
              ? new Date(userDetails.createdAt).toLocaleString()
              : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {userDetails.updatedAt
              ? new Date(userDetails.updatedAt).toLocaleString()
              : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Email Verified">
            {userDetails.emailVerified ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Phone Verified">
            {userDetails.phoneVerified ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Is Active">
            {userDetails.isActive ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Is Account Locked">
            {userDetails.isAccountLocked ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Is PIN Locked">
            {userDetails.isPinLocked ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Is Fully Verified">
            {userDetails.isFullyVerified ? "Yes" : "No"}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Layout>
  );
};

// <Form
//   form={form}
//   layout="vertical"
//   onFinish={onFinish}
//   initialValues={userDetails}
// >
//   {/* Form Items */}
// </Form>
